import { AccountEntity, ProfileEntity, UserEntity } from '@interpals/api-web';
import { TFunction } from 'i18next';

import { formatDistanceToNowStrictLower } from './formatDate';
import { localeLowerCase } from './i18n';

export default (t: TFunction, user?: AccountEntity | ProfileEntity | UserEntity): string =>
    user?.online
        ? localeLowerCase(t('Common.OnlineStatus.Online'))
        : user?.last_login
          ? t('Common.OnlineStatus.LastSeen', {
                date: formatDistanceToNowStrictLower(new Date(user?.last_login), { addSuffix: true }),
            })
          : '';
